var map = {
	"./amex.svg": [
		"d182",
		"icon amex-svg"
	],
	"./angle-down.svg": [
		"b404",
		"icon angle-down-svg"
	],
	"./angle-right.svg": [
		"8cbd",
		"icon angle-right-svg"
	],
	"./aura.svg": [
		"b594",
		"icon aura-svg"
	],
	"./banrisul.svg": [
		"1b54",
		"icon banrisul-svg"
	],
	"./bb.svg": [
		"facde",
		"icon bb-svg"
	],
	"./bcash.svg": [
		"35b1",
		"icon bcash-svg"
	],
	"./billet.svg": [
		"4d0f",
		"icon billet-svg"
	],
	"./box.svg": [
		"e36a",
		"icon box-svg"
	],
	"./bradesco.svg": [
		"4300",
		"icon bradesco-svg"
	],
	"./check-circle.svg": [
		"9652",
		"icon check-circle-svg"
	],
	"./check.svg": [
		"a7c0",
		"icon check-svg"
	],
	"./circle.svg": [
		"77ee",
		"icon circle-svg"
	],
	"./curious-woman.svg": [
		"8930",
		"icon curious-woman-svg"
	],
	"./deposit.svg": [
		"0283",
		"icon deposit-svg"
	],
	"./diners.svg": [
		"6d36",
		"icon diners-svg"
	],
	"./discover.svg": [
		"4eff",
		"icon discover-svg"
	],
	"./ellipse.svg": [
		"9521",
		"icon ellipse-svg"
	],
	"./elo.svg": [
		"ccb7",
		"icon elo-svg"
	],
	"./exclamation-circle.svg": [
		"a4d9",
		"icon exclamation-circle-svg"
	],
	"./exclamation-triangle.svg": [
		"d514",
		"icon exclamation-triangle-svg"
	],
	"./exclamation.svg": [
		"3186",
		"icon exclamation-svg"
	],
	"./hiper.svg": [
		"2240",
		"icon hiper-svg"
	],
	"./hipercard.svg": [
		"9aaf",
		"icon hipercard-svg"
	],
	"./hsbc.svg": [
		"929e",
		"icon hsbc-svg"
	],
	"./itau.svg": [
		"e4cc",
		"icon itau-svg"
	],
	"./jcb.svg": [
		"4f3d",
		"icon jcb-svg"
	],
	"./maestro.svg": [
		"83bd",
		"icon maestro-svg"
	],
	"./mastercard.svg": [
		"543b",
		"icon mastercard-svg"
	],
	"./mercadopago.svg": [
		"439e",
		"icon mercadopago-svg"
	],
	"./moip.svg": [
		"50d1",
		"icon moip-svg"
	],
	"./pagseguro.svg": [
		"fbb0",
		"icon pagseguro-svg"
	],
	"./paper-plane.svg": [
		"512e",
		"icon paper-plane-svg"
	],
	"./paypal.svg": [
		"7c7e",
		"icon paypal-svg"
	],
	"./peela.svg": [
		"109b",
		"icon peela-svg"
	],
	"./pix.svg": [
		"441c",
		"icon pix-svg"
	],
	"./question-circle.svg": [
		"adcc",
		"icon question-circle-svg"
	],
	"./security.svg": [
		"f901",
		"icon security-svg"
	],
	"./times.svg": [
		"e5ec",
		"icon times-svg"
	],
	"./trash-alt.svg": [
		"e035",
		"icon trash-alt-svg"
	],
	"./traycheckout.svg": [
		"ceb2",
		"icon traycheckout-svg"
	],
	"./user-lock.svg": [
		"a8a7",
		"icon user-lock-svg"
	],
	"./visa.svg": [
		"53f8",
		"icon visa-svg"
	],
	"./visaelectron.svg": [
		"b42a",
		"icon visaelectron-svg"
	],
	"./waiting-list-empty-state.svg": [
		"e048",
		"icon waiting-list-empty-state-svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "c951";
module.exports = webpackAsyncContext;